import produce from 'immer';
import storage from 'helpers/storage';
import * as types from 'actions/profile/types';

const initialState = {
  isLoggedIn: false,
  isLoading: false,
  isUsingDefaultPin: storage.get('isUsingDefaultPin') !== 'false',
  loginData: null,
  error: null,
  data: {},
};

export default produce((draft, action) => {
  switch (action.type) {
    case types.LOGIN:
      draft.isLoading = true;
      draft.isLoggedIn = false;
      draft.error = null;
      break;
    case types.LOGIN_SUCCESS:
    case types.FETCH_SUCCESS:
      draft.isLoading = false;
      draft.isLoggedIn = true;
      draft.data = action.payload;
      draft.error = null;
      break;
    case types.LOGIN_ERROR:
    case types.FETCH_ERROR:
      draft.error = action.payload;
      draft.isLoading = false;
      break;
    case types.LOGOUT:
      draft.isLoading = true;
      break;
    case types.LOGOUT_SUCCESS:
      return { ...initialState };
    case types.FETCH_BALANCE:
      draft.isLoading = true;
      break;
    case types.FETCH_BALANCE_SUCCESS:
      draft.data.balance = action.payload;
      break;
    case types.FETCH_BALANCE_ERROR:
      draft.error = action.payload;
      break;
    case types.SET_IS_USING_DEFAUL_PIN:
      draft.isUsingDefaultPin = action.payload;
      break;
    case types.SET_LOGIN_DATA:
      draft.loginData = action.payload;
      break;
    default:
    // nothing
  }
}, initialState);
